import React, { useEffect, useState } from "react";
import "./LicensesTable.scss";
import { T } from "services/lang/LanguageService";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { DatasetDataApi } from "api/DatasetDataApi";
import { ILicenseDataInfo } from "../../../api/model/user/ILicenseDataInfo";

type TablePrinterProps = {
  obj: any;
};

function LicensesTable() {
  const [allData, setAllData] = useState<Array<ILicenseDataInfo>>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [dialogName, setDialogName] = useState<string>("");
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [showData, setShowData] = useState<any>(undefined);

  useEffect(() => {
    DatasetDataApi.getLicenses().then(({ data, error }) => {
      if (error) {
        return;
      }
      if (data) {
        data[0].title = T("word.name");
        setLoading(false);
        if (data.length === 0) {
          return;
        }

        setAllData(data);
      }
    });
  }, []);

  const featuresBody = (rowData: ILicenseDataInfo) => {
    return (
      <div className="table-button-window">
        <div className="table-button" onClick={() => showDialogMethod(rowData, "features")}>
          <i className="pi pi-list" />
        </div>
      </div>
    );
  };

  const otherFeaturesBody = (rowData: ILicenseDataInfo) => {
    return (
      <div className="table-button-window">
        <div className="table-button" onClick={() => showDialogMethod(rowData, "otherFeatures")}>
          <i className="pi pi-list" />
        </div>
      </div>
    );
  };

  const filterFeatures = (data: any) => {
    const newObj = Object();
    Object.keys(data).forEach(keyName => {
      if (keyName.search("ΩPLACEHOLDER")) {
        newObj[keyName] = data[keyName];
      }
    });
    return newObj;
  };

  const showDialogMethod = (rowData: ILicenseDataInfo, properties: string) => {
    if (properties === "features") {
      setShowData(CalculateTablesToRender(filterFeatures(rowData.features)));
      setDialogName(T("word.features"));
    } else if (properties === "otherFeatures") {
      setDialogName(T("word.other-features"));
      setShowData(CalculateTablesToRender(rowData.otherFeatures));
    }
    setShowDialog(true);
  };

  const CalculateTablesToRender = (data: any) => {
    let VAR_COUNTER = 10;

    // Save window from formatting more than 3 tables
    if (VAR_COUNTER * 3 < Object.keys(data!).length) {
      VAR_COUNTER = Object.keys(data!).length / 3;
    }

    let counter = 0;
    let newTempObject;

    const tempArr = [];

    while (counter < Object.keys(data!).length) {
      newTempObject = Object();
      for (let i = 0; i < VAR_COUNTER; i++) {
        if (Object.keys(data!).length > counter) {
          newTempObject[Object.keys(data!)[counter]] = Object.values(data!)[counter];
          counter++;
        }
      }
      tempArr.push(newTempObject);
    }

    return tempArr;
  };

  const PrintTables = () => {
    return (
      <div className="flex-container">
        {showData?.map((obj: any, key: any) => {
          return <PrintTable obj={obj} key={key} />;
        })}
      </div>
    );
  };

  const PrintTable = (tableObject: TablePrinterProps) => {
    return (
      <div style={{ overflowX: "auto" }}>
        <table className="table-full">
          <thead>
            <tr>
              <th style={{ width: "10px", whiteSpace: "nowrap" }} />
              <th style={{ width: "10px", whiteSpace: "nowrap" }} />
            </tr>
          </thead>
          <tbody>
            {tableObject &&
              Object.keys(tableObject!.obj).map((keyName: string, keyIndex: number) => {
                return (
                  <tr key={keyIndex}>
                    <td>{keyName}</td>
                    <td>
                      {tableObject.obj[keyName] === true || tableObject.obj[keyName] === "true" ? (
                        <i className="pi pi-check" />
                      ) : tableObject.obj[keyName] === false ||
                        tableObject.obj[keyName] === "false" ? (
                        <i className="pi pi-times" />
                      ) : (
                        tableObject.obj[keyName]
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    );
  };

  const descriptionEditor = (options: ColumnEditorOptions) => {
    return (
      <InputTextarea
        rows={2}
        value={options.value}
        onChange={e => {
          options.editorCallback!(e.target.value);
        }}
        style={{ width: "100%" }}
      />
    );
  };

  const nameEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        type="text"
        value={options.value ? options.value : ""}
        onChange={e => {
          options.editorCallback!(e.target.value);
        }}
      />
    );
  };

  const rowEditCompleted = (e: any) => {
    console.log(e);
  };

  const rowEditCanceled = () => {
    console.log("cancel");
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="Id"
          rowSpan={2}
          filter
          filterField="id"
          filterPlaceholder={T("action.search-by-id")}
        />
        <Column
          header={T("word.name")}
          rowSpan={2}
          filter
          filterField="name"
          filterPlaceholder={T("action.search-by-name")}
        />
        <Column style={{ whiteSpace: "nowrap" }} header={`Max. ${T("word.version")}`} rowSpan={2} />
        <Column header={T("word.description")} rowSpan={2} />
        <Column header={T("word.features")} rowSpan={2} />
        <Column style={{ whiteSpace: "nowrap" }} header={T("word.other-features")} rowSpan={2} />
        <Column className="merge-column" header={T("word.node-count")} colSpan={3} />
        <Column rowSpan={2} />
      </Row>
      <Row>
        <Column
          style={{ whiteSpace: "nowrap" }}
          header="AC"
          field="maxBus"
          sortable
          sortField="maxBus"
        />
        <Column
          style={{ whiteSpace: "nowrap" }}
          header="DC"
          field="maxDCNode"
          sortable
          sortField="maxDCNode"
        />
        <Column
          style={{ whiteSpace: "nowrap" }}
          header={T("word.hydraulic")}
          field="maxHNode"
          sortable
          sortField="maxHNode"
        />
      </Row>
    </ColumnGroup>
  );

  return (
    <>
      <DataTable
        value={allData}
        responsiveLayout="scroll"
        size="small"
        showGridlines
        sortMode="multiple"
        removableSort
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={`${T("word.showing")} {first} to {last} of {totalRecords}`}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
        loading={loading}
        headerColumnGroup={headerGroup}
        editMode="row"
        onRowEditComplete={rowEditCompleted}
        onRowEditCancel={rowEditCanceled}
      >
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} field="id" />
        <Column
          style={{ width: "10px", whiteSpace: "nowrap" }}
          field="name"
          editor={options => nameEditor(options)}
        />
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} field="maxAllowedVersion" />
        <Column field="description" editor={options => descriptionEditor(options)} />
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} body={featuresBody} />
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} body={otherFeaturesBody} />

        <Column style={{ width: "10px", whiteSpace: "nowrap" }} field="maxBus" />
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} field="maxDCNode" />
        <Column style={{ width: "10px", whiteSpace: "nowrap" }} field="maxHNode" />

        <Column rowEditor style={{ width: "10px", whiteSpace: "nowrap" }} />
      </DataTable>

      <Dialog
        header={dialogName}
        visible={showDialog}
        modal
        resizable={false}
        onHide={() => {
          setShowDialog(false);
        }}
      >
        {showData && <PrintTables />}
      </Dialog>
    </>
  );
}

export default LicensesTable;
